export let OnboardingWidgetState = /*#__PURE__*/function (OnboardingWidgetState) {
  OnboardingWidgetState["ShouldReveal"] = "shouldReveal";
  OnboardingWidgetState["StaticOpened"] = "staticOpened";
  OnboardingWidgetState["ShouldDisappear"] = "shouldDisappear";
  OnboardingWidgetState["Hidden"] = "hidden";
  return OnboardingWidgetState;
}({});